import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const AdminDashboard = () => {
  const [counts, setCounts] = useState({
    patients: null,
    professionals: null,
    appointments: null,
  });

  const API_URL = 'https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod';

  useEffect(() => {
    Promise.all([
      fetch(`${API_URL}/admin/stats/patients-count`).then(res => res.json()),
      fetch(`${API_URL}/admin/stats/professionals-count`).then(res => res.json()),
      fetch(`${API_URL}/admin/stats/appointments-count`).then(res => res.json())
    ])
      .then(([patients, professionals, appointments]) => {
        setCounts({
          patients: patients.count,
          professionals: professionals.count,
          appointments: appointments.count,
        });
      })
      .catch(err => console.error('Erreur chargement des statistiques admin:', err));
  }, []);

  return (
    <div style={{ padding: '20px' }}>
      <h2>🎛️ Tableau de bord Admin</h2>
      <p>Bienvenue dans le portail d'administration. Choisissez une section :</p>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        <li style={itemStyle}>
          <Link to="/admin/patients">
            👥 Voir les patients {counts.patients !== null && `(${counts.patients})`}
          </Link>
        </li>
        <li style={itemStyle}>
          <Link to="/admin/professionnels">
            👨‍⚕️ Voir les professionnels {counts.professionals !== null && `(${counts.professionals})`}
          </Link>
        </li>
        <li style={itemStyle}>
          <Link to="/admin/rendezvous">
            📅 Voir les rendez-vous {counts.appointments !== null && `(${counts.appointments})`}
          </Link>
        </li>
        <li style={itemStyle}>
          <Link to="/admin/statistiques">
            📊 Voir les statistiques
          </Link>
        </li>
      </ul>
    </div>
  );
};

const itemStyle = {
  background: '#f0f0f0',
  padding: '10px',
  margin: '10px 0',
  borderRadius: '8px'
};

export default AdminDashboard;